import { __awaiter } from "tslib";
import { useBCAIS, useCopilotEligible, } from '@office-start/copilot-route-service';
import { useEffect, useState } from 'react';
import { findAppDefinitionById } from '../findAppDefinitionById';
/**
 * @description Get Application definition based on appId
 * @param appId used to search for app definition
 * @returns UseAppDefinitionResult
 */
export const useAppDefinitionById = (appId, locStrings) => {
    const [appDefinition, setAppDefinition] = useState(undefined);
    const [missingAppDefinition, setMissingAppDefinition] = useState(false);
    const isEligibleForAnyCopilot = useCopilotEligible();
    const isBCAISContext = useBCAIS();
    useEffect(() => {
        let isMounted = true;
        const fetchDefinition = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!appId) {
                return;
            }
            const fetchedAppDefinition = yield findAppDefinitionById(appId, isEligibleForAnyCopilot, locStrings, isBCAISContext);
            if (isMounted) {
                if (!fetchedAppDefinition) {
                    setMissingAppDefinition(true);
                }
                else {
                    setAppDefinition(fetchedAppDefinition);
                }
            }
        });
        fetchDefinition();
        return () => {
            isMounted = false;
        };
    }, [appId]);
    return { appDefinition, missingAppDefinition };
};
//# sourceMappingURL=useAppDefinitionById.js.map